export const content = {
  format: 'Format',
  buchungsnummer: 'Buchungsnummer(n)',
  mussKopplung: 'Muss-Kopplung',
};
